import * as z from "zod";
import { literal, string } from "zod";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
export const ConfirmToolCallMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CONFIRMATION_PROMPT),
  structuredContent: string().optional(),
});

export type ConfirmToolCallMessage = z.infer<
  typeof ConfirmToolCallMessageSchema
>;

export const ConfirmToolCallMessageDbParser =
  ConfirmToolCallMessageSchema.merge(AutoGeneratedFieldsSchema);
